module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dynamic-pricing-rule-component"
  }, [_c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), _c('div', [(_vm.errors.message) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.message)))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Selected products')))]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Wybrano " + _vm._s(_vm.getSelected) + " z " + _vm._s(_vm.getTotalRows) + " produkt/ów")])]), _vm._v(" "), (_vm.hasError('selectedRows')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.selectedRows)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', [_vm._v(_vm._s(_vm.t('Changes made in the dashboard do not affect the rules in the source from which you provide us with data. If you revert to automatic rule management, please ensure that the source contains the appropriate rule tags.')))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6 form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.t('Set auto accept')))]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "placeholder": _vm.t('Select'),
      "options": _vm.availableAutoAcceptOptions,
      "multiple": false,
      "close-on-select": true,
      "clear-on-select": false,
      "track-by": "id",
      "label": "name",
      "loading": false
    },
    model: {
      value: (_vm.inputs.autoAccept),
      callback: function($$v) {
        _vm.$set(_vm.inputs, "autoAccept", $$v)
      },
      expression: "inputs.autoAccept"
    }
  }, [_c('div', {
    attrs: {
      "slot": "noOptions"
    },
    slot: "noOptions"
  }, [_vm._v(_vm._s(_vm.t('List is empty')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 form-group"
  }, [(_vm.hasError('autoAccept')) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.t(_vm.errors.autoAccept)))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-confirm",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.t('Submit')) + "\n                ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6811389a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DynamicPricingProductSetAutoAcceptComponent.vue
// module id = 1314
// module chunks = 2